import {Facet, Tag} from '../models/tag';

export const TAG_PROFILES: Record<string, {Label: string; Facets: Facet[]}> = {
  DATA_CENTER: {
    Label: 'Data Center',
    Facets: [
      {ID: '34218a5d-5a63-44f9-9201-6cfde00cb9e9', Label: 'Building'},
      {ID: '8756854f-1482-4836-9703-58986c771528', Label: 'Location'},
      {ID: '13a6f95c-1803-44cd-9e00-48df76bdd40e', Label: 'Room Type'},
      {ID: '597a9870-c91f-4138-bccb-24fa378163c2', Label: 'Equipment'},
      {ID: '20f73c7e-de37-4f97-8488-c7896283cd49', Label: 'Row'},
      {ID: '7161a708-71c4-419a-bcea-c2244741c9e9', Label: 'City'},
    ],
  },
};

const _facetOrder = new Map(
  Object.values(TAG_PROFILES).flatMap(p => p.Facets).map((f, i) => [f.ID, i])
);

export function sortByProfileOrder<T extends Pick<Tag, 'ID'>>(facets: T[]): T[] {
  return [...facets].sort((a, b) => (_facetOrder.get(a.ID) ?? Number.MAX_SAFE_INTEGER) - (_facetOrder.get(b.ID) ?? Number.MAX_SAFE_INTEGER));
}
